import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FrotaService } from 'src/app/frota/frota.service';
import { IFiltroFrotaContatoModel, IFrotaContatoModel, IFrotaModel } from 'src/app/frota/model/frota.model';
import { IMunicipioModel } from 'src/app/model/municipio.model';
import { LoginModel } from 'src/app/model/login.model';
import { BuscaCEPService } from 'src/app/services/busca-cep.service';
import { CorporativoService } from 'src/app/services/corporativo.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { IEnderecoSubFrotaModel, IFiltroSubFrotaModel, ISubFrotaModel } from '../model/subFrota.model';
import { SubfrotaService } from '../subfrota.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { TipoEntidades } from '../model/TipoEntidades';



@Component({
  selector: 'app-subfrota-edit',
  templateUrl: './subfrota-edit.component.html',
  providers: [{
    provide: MAT_RADIO_DEFAULT_OPTIONS,
    useValue: { color: 'primary' },
  }],
  styleUrls: ['./subfrota-edit.component.scss']
})
export class SubfrotaEditComponent implements OnInit, OnDestroy {

  cepmask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  cnpjmask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

  tipoEntidades = TipoEntidades;

  usuario !: LoginModel | undefined;

  private subs = new Subscription();

  subFrotasFaturamento!: ISubFrotaModel[];
  subFrota: ISubFrotaModel = { flagPadrao: 'N', flagCentroCusto: 'N', flagBloqueioPostoNovo: '0', enderecos: [{ tipo: 'C', endereco: '', cep: '' }, { tipo: 'B', endereco: '', cep: '' }] };

  frotaContatos!: IFrotaContatoModel[];

  isUpdate = false;

  ufs!: any[];

  cidadesFat!: IMunicipioModel[];
  cidadesEnv!: IMunicipioModel[];

  loading = 0;

  constructor(
    private subFrotaService: SubfrotaService,
    private frotaService: FrotaService,
    private corporativoService: CorporativoService,
    private authenticationService: AuthenticationService,
    private buscaCepService: BuscaCEPService,
    private snackBar: SnackBarService,
    private renderer: Renderer2,
    private localStorageService: LocalStorageService,
    private router: Router) {

  }

  ngOnInit(): void {


    // Liga a animação de Loading (Spinner) na tela
    this.loading++;

    this.usuario = this.subFrotaService?.usuario;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.subFrotaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {

          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {

          this.iniciar();

        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });
  }

  private iniciar() {

    this.renderer.addClass(document.body, this.usuario?.retorno?.aparencia ?? 'PADRAO');

    this.isUpdate = this.router.url === '/subfrota/alterar' ? true : false;

    this.ufs = this.subFrotaService.returnAllUfs();

    if (this.usuario?.retorno?.tipo === this.tipoEntidades.frota) {
      this.setFrota(this.usuario.retorno.codigoEntidade, this.usuario.retorno.nomeFantasia);
    }

    if (this.isUpdate) {
      // Se é alteração verifica o codigoSubFrota setado no serviço para recuparar os dados. Senão foi setado, força redirecionamento para a tela de consulta.
      if (this.subFrotaService.codigoSubFrota)
        this.obter();

      else
        this.router.navigateByUrl('/subfrota');
    } else {
      this.trataLocalStorage();
    }
  }

  private trataLocalStorage() {
    if (sessionStorage.getItem('filtroFrota')) {
      var filtroFrota = JSON.parse(sessionStorage.getItem('filtroFrota') ?? '{}');
      if (filtroFrota.guid === this.subFrotaService.usuario.retorno.guid) {
        if (filtroFrota.frota && filtroFrota.frota.codigo) {
          this.setFrota(filtroFrota.frota.codigo, filtroFrota.frota.nomeReduzido);
        }
      } else {
        sessionStorage.removeItem('filtroFrota');
      }
    }
  }

  selecionaFrota(frota: IFrotaModel | null) {

    if (!frota || !frota.codigo) {
      this.subFrota.codigoFrota = null;
    } else {
      this.setFrota(frota.codigo, frota.nomeReduzido);
    }
  }

  setFrota(codigo: number, nomeReduzido: string) {
    this.subFrota.codigoFrota = codigo;
    this.subFrota.nomeReduzidoFrota = nomeReduzido;

    this.getFrotaContatos();
    this.getSubFrotasFaturamento();
  }

  onChangeCentroCusto(flagCentroCusto: string) {
    if (flagCentroCusto === "S") {
      this.subFrota.subFrotaCentroCusto = this.subFrota.codigo;
    } else {
      this.subFrota.subFrotaCentroCusto = this.subFrotasFaturamento.find(d => d.flagPadrao === 'S')?.codigo;
    }
    this.subFrota.cnpj = undefined;
    this.subFrota.emailNfe = undefined;
    this.subFrota.inscr = undefined;
    this.subFrota.iest = undefined;
    this.subFrota.codigoContato = undefined;
  }

  onChangeCep(cep: string, endereco: IEnderecoSubFrotaModel, tipo: string) {

    if (cep) {

      cep = cep.replace('-', '').replace('_', '');

      if (cep.length === 8) {

        this.loading++;
        this.subs.add(this.buscaCepService.buscaCEP(cep)
          .subscribe({
            next: (res) => {

              if (res?.sucesso) {
                endereco.endereco = res.retorno.logradouro;
                endereco.bairro = res.retorno.bairro;
                endereco.estado = res.retorno.uf;
                this.onChangeUF(res.retorno.uf, tipo, endereco, res.retorno.localidade);

                if (res.retorno.numeroEndereco && res.retorno.numeroEndereco != '' && res.retorno.numeroEndereco != '0')
                  endereco.numero = res.retorno.numeroEndereco;
                else
                  endereco.numero = undefined;

                endereco.complemento = undefined;
              }
            },
            complete: () => {
              this.loading--;
            },
            error:() => {
              this.loading--;
            },
          }));

      }
    }
  }

  onChangeUF(uf: string | undefined, tipo: string, endereco: IEnderecoSubFrotaModel, cidade?: string) {

    if (uf !== undefined && uf !== null) {

      if (uf.trim() === "") {
        if (tipo === 'ENV') {
          this.cidadesEnv = [];
        } else if (tipo === 'FAT') {
          this.cidadesFat = [];
        }
        endereco.cidade = "";

      } else {

        this.loading++;

        this.subs.add(this.corporativoService.consultaMunicipios(uf)
          .subscribe({
            next: (res) => {
              if (res?.sucesso) {
                if (tipo === 'ENV') {
                  this.cidadesEnv = res.retorno;
                } else if (tipo === 'FAT') {
                  this.cidadesFat = res.retorno;
                }
                if (cidade && cidade.trim() !== "") {
                  endereco.cidade = cidade?.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                }
              }
            },
            complete: () => {
              this.loading--;
            }
          }));
      }
    }
  }

  private getSubFrotasFaturamento() {

    const filtro: IFiltroSubFrotaModel = { guid: this.subFrotaService.usuario.retorno.guid, codigoFrota: this.subFrota.codigoFrota, flagCentroCusto: "S" };
    this.loading++;

    this.subs.add(this.subFrotaService.listSubFrotas(filtro)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.subFrotasFaturamento = res.retorno;
            if (this.isUpdate) {
              let index = this.subFrotasFaturamento.findIndex(d => d.codigo === this.subFrotaService.codigoSubFrota); //find index in your array
              if (index >= 0)
                this.subFrotasFaturamento.splice(index, 1);//remove element from array
            } else {
              this.subFrota.subFrotaCentroCusto = this.subFrotasFaturamento.find(d => d.flagPadrao === 'S')?.codigo;
            }
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  private getFrotaContatos() {

    const filtroContato: IFiltroFrotaContatoModel = { guid: this.subFrotaService.usuario.retorno.guid, codigoFrota: this.subFrota.codigoFrota };
    this.loading++;

    this.subs.add(this.frotaService.listFrotaContatos(filtroContato)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.frotaContatos = res.retorno;
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  obter() {
    this.loading++;

    const filtro = { guid: this.subFrotaService.usuario.retorno.guid, codigoSubFrota: this.subFrotaService.codigoSubFrota };

    this.subs.add(this.subFrotaService.obter(filtro)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {

            this.subFrota = res.retorno;

            if (this.subFrota.indPermiteConfiguracaoContingencia === 1) {
              if ((this.subFrota.codigoContingencia?.trim() ?? "") === "") {
                this.subFrota.codigoContingencia = '1';
              }

              if ((this.subFrota.codigoTipoContingencia?.trim() ?? "") === "") {
                this.subFrota.codigoTipoContingencia = '1';
              }
              if ((this.subFrota.codigoIntervaloContingencia?.trim() ?? "") === "") {
                this.subFrota.codigoIntervaloContingencia = '1';
              }
            }

            this.onChangeUF(this.subFrota?.enderecos[1]?.estado ?? '', 'ENV', this.subFrota?.enderecos[1], this.subFrota?.enderecos[1]?.cidade);

            this.onChangeUF(this.subFrota?.enderecos[0]?.estado ?? '', 'FAT', this.subFrota?.enderecos[0], this.subFrota?.enderecos[0]?.cidade);

            this.getFrotaContatos();

            this.getSubFrotasFaturamento();
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }


  onSubmit(f: any): void {

    if (!f.form.valid) {
      this.snackBar.flashMessage('Favor corrigir os campos marcados.', ['snackbar-error'], 'Fechar', 0);
      return;
    }

    this.subFrota.guid = this.subFrotaService.usuario.retorno.guid;

    if (this.isUpdate)
      this.alterar();
    else
      this.incluir();
  }

  private alterar() {

    this.loading++;

    this.subs.add(this.subFrotaService.alterar(this.subFrota)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.snackBar.flashMessage('Sub-Frota alterada com sucesso.', ['snackbar-info'], 'Fechar', 0);
            this.router.navigateByUrl('/subfrota');
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  private incluir() {

    this.loading++;

    this.subs.add(this.subFrotaService.incluir(this.subFrota)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.snackBar.flashMessage('Sub-Frota cadastrada com sucesso.', ['snackbar-info'], 'Fechar', 0);
            this.router.navigateByUrl('/subfrota');
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

  copiarEndereco() {
    Object.assign(this.subFrota.enderecos[0], this.subFrota.enderecos[1]);
    this.onChangeUF(this.subFrota.enderecos[0].estado ?? '', 'FAT', this.subFrota.enderecos[0], this.subFrota.enderecos[1].cidade);
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

}

